module.exports = __webpack_public_path__ + "media/images/soar/terms_page_figure1-e6b64d1c205cf7c7b2e885526af93937.png";